

























































































import { Component } from "vue-property-decorator";
import NotificationEvent from "@/resources/mixins/notifications/notificationEvent";
import { mixins } from "vue-class-component";
@Component({
  name: "game-killer-vote-winner-modal-component",
})
export default class GameKillerVoteAndWinnerModalComponent extends mixins(
  NotificationEvent
) {
  mounted() {}
  get active() {
    const e =
      this.$store.getters["SystemStore/getGameKillerVoteAndWinnerModal"];
    return e;
  }
  get space() {
    return this.$store.getters["SpaceStore/getSpace"];
  }
  set active(e) {
    this.$store.dispatch(
      "SystemStore/setGameKillerVoteAndWinnerModalAction",
      e
    );
  }
  get gameData() {
    let data = this.$store.getters["GameKillerStore/getGameKillerData"];
    return data;
  }
  get gamekillerWinner() {
    let data = this.$store.getters["SystemStore/getGameKillerWinner"];
    return data;
  }
  close() {
    this.active = false;
  }
}
